import {computed, Injectable, signal} from '@angular/core';
import {showVacas} from '@kilobytelab/domain';
import {checkVer} from '@kilobytelab/core';
import {Alumno, DatosApp, Matricula, Padre} from '@kilobytelab/types';
import {CONFIG} from '../app.constants';
import {DateTime} from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  version = signal<string>(null);
  APP = signal<DatosApp>(null);
  indiceAlumno = signal<number>(0);
  PADRE = signal<Alumno[]>([]); // <-- Todos los alumnos del padre
  PADRES = signal<[Padre, Padre]>(null); // <-- Datos de los padres, el primero es el que usa la app
  matriculaDisponible = signal<boolean>(false);
  streamDisponible = signal<boolean>(false);
  showAvatar = signal<boolean>(true);
  fechas = signal<{agendas: string, avisos: string}>(null);
  pushRecibidoTrigger = signal<number>(0);
  appLista = signal<boolean>(false);

  ALUMNO = computed<Alumno>(() => this.PADRE()[this.indiceAlumno()]);
  showVacaciones = computed<boolean>(() => showVacas(this.APP()?.vacaciones));
  mostrarVersion = computed<boolean>(() => checkVer(this.version(), CONFIG.VERSION));
  showGaleria = computed<boolean>(() => {
    const appInfo = this.APP();
    const alumnos = this.PADRE() || [];
    if (!appInfo?.fotos || !alumnos.length) return false;
    const limiteBaja = DateTime.local().minus({months: CONFIG.MESES_DE_GRACIA});
    const alumnosActivos = alumnos.filter(a => {
      if (a.estado === 'alta') return true;
      if (a.estado === 'baja' && a.fbaja) {
        const fecha = DateTime.fromSQL(a.fbaja);
        return fecha > limiteBaja
      }
      return false
    });
    if (!alumnosActivos.length) return false;
    return alumnosActivos.every(a => a.Fotos && a.RGPD)
  });
  MATRICULAS = computed<Matricula[]>(() => {
    return this.PADRE().map(a => ({
      idAlumno: a.id,
      copia: a.copia,
      SEPA: a.SEPA,
      RGPD: a.RGPD,
      Fotos: a.Fotos,
      time: a.time
    }))
  })
}